<script setup>
import { useI18n } from 'vue-i18n';
import { useWgptAuditTrail } from 'dashboard/composables/wgpt/wgptAuditTrail';

import Input from 'next/input/Input.vue';
import TextArea from 'next/textarea/TextArea.vue';
import AuditTrails from './TaskEditorAuditTrails.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();
const { isFeatureEnabled } = useWgptAuditTrail();
</script>

<template>
  <div class="p-6 flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-medium leading-6 text-n-slate-12">
        <span class="truncate">
          {{ t('WGPT_TASKS.EDITOR.SETTINGS.TITLE') }}
        </span>
      </h3>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('WGPT_TASKS.EDITOR.SETTINGS.DESCRIPTION_HELP') }}
      </p>
    </div>

    <div class="flex flex-col gap-4">
      <Input
        :model-value="props.modelValue.name"
        :label="t('WGPT_TASKS.EDITOR.SETTINGS.NAME')"
        @update:model-value="
          emit('update:modelValue', { ...props.modelValue, name: $event })
        "
      />
      <TextArea
        :model-value="props.modelValue.description"
        :label="t('WGPT_TASKS.EDITOR.SETTINGS.DESCRIPTION')"
        rows="3"
        @update:model-value="
          emit('update:modelValue', {
            ...props.modelValue,
            description: $event,
          })
        "
      />
    </div>

    <template v-if="isFeatureEnabled">
      <div class="border-t border-n-weak my-4" />

      <AuditTrails />
    </template>
  </div>
</template>
